import React from 'react';
import { Button, useTranslation } from '@testsigma/atoms';
import tickIcon from '@images/tick.svg';

import { useConnectionSuccess } from '../../hooks';

const UserConnectionSuccessfulScreen: React.FC = () => {
  const { t } = useTranslation();
  const { connectionName, handleDone } = useConnectionSuccess();

  return (
    <>
      <div className='py-10 px-6'>
        <div className='flex flex-col items-center justify-center h-full'>
          <div className='mt-3 text-primary-1000 leading-8 text-2xl'>
            {t('user-connection-successful.status.label')}
          </div>

          <div className='my-10'>
            <img
              src={tickIcon}
              className='empty-illustration'
              alt='Tick Illustration'
            />
          </div>

          <span className='mb-10 text-center'>
            {t('user-connection-successful.message', {
              connectionName: connectionName,
            })}
          </span>

          <Button type='primary' onClick={handleDone}>
            {t('common.done')}
          </Button>
        </div>
      </div>
    </>
  );
};

export { UserConnectionSuccessfulScreen };
